const mobileAppEventType = {
    generalMessage: "generalMessage",  // web -> mobile app, mobile app -> web
    loginData: "loginData", // web -> mobile app
    getOtp: "getOtp", // web -> mobile app
    getHash: "getHash", // web -> mobile app
    sensorAvailable: "sensorAvailable", // mobile app -> web
    sensorAvailableAndEnabled: "sensorAvailableAndEnabled", // mobile app -> web
    showSensor: "showSensor", // web -> mobile app
    biometricsRegistration: "biometricsRegistration", // web -> mobile app
    biometricsDisabling: "biometricsDisabling", // web -> mobile app
    base64Download: "base64Download", // web -> mobile app
    mailTo: "mailTo", // web -> mobile app
    sendWhatsapp: "sendWhatsapp", // web -> mobile app
};

export default Object.freeze(mobileAppEventType);